import {
  ClinicalTrialInventoryInstrumentType,
  ClinicalTrialInventoryMeasurementType,
  ClinicalTrialInventoryReaderType,
} from '@dynamika-shared/types/clinicalTrialInventory';
import { getValueWithTooltip } from '@dynamika-shared/ui/Table/getValueWithTooltip';
import { ClinicalInventoryColumnsContext } from 'src/pages/ClinicalTrial/Readings/ReadingInventory/components/ClinicalTrialInventory.columns';
import {
  getScoringFormById,
  getUserById,
} from 'src/pages/ClinicalTrial/Readings/ReadingInventory/components/helpers';

const LENGTH_FOR_TOOLTIP = 10;

const loadingRenderer = (width: string) => (
  <div
    className={`h-2 ${width} animate-pulse rounded-[5px] bg-brightGray`}
  ></div>
);

const commonColumnProps = {
  cellClassName: 'max-w-full min-w-0 grow',
  tdClassName: 'min-w-full max-w-[30rem] mr-1',
};

export const clinicalTrialInventorySchema = {
  common: [
    {
      name: 'code',
      header: () => 'Code',
      getValue: getValueWithTooltip('code', LENGTH_FOR_TOOLTIP),
      hasSorting: true,
      ...commonColumnProps,
      thClassName: 'w-[20.5%] min-w-[20.5%] max-w-[20.5%]',
      loading: (index?: number) =>
        loadingRenderer(Number(index) % 2 ? 'w-[20rem]' : 'w-[15rem]'),
    },
    {
      name: 'name',
      header: () => 'Name',
      getValue: getValueWithTooltip('name', LENGTH_FOR_TOOLTIP),
      hasSorting: true,
      ...commonColumnProps,
      thClassName: 'w-[20.5%] min-w-[20.5%] max-w-[20.5%]',
      loading: (index?: number) =>
        loadingRenderer(Number(index) % 2 ? 'w-[20rem]' : 'w-[15rem]'),
    },
    {
      name: 'description',
      header: () => 'Description',
      getValue: getValueWithTooltip('description', LENGTH_FOR_TOOLTIP),
      hasSorting: true,
      ...commonColumnProps,
      thClassName: 'w-[22%] min-w-[22%] max-w-[22%]',
      loading: (index?: number) =>
        loadingRenderer(Number(index) % 2 ? 'w-[22rem]' : 'w-[17rem]'),
    },
  ],
  specific: {
    measurements: (ctx: ClinicalInventoryColumnsContext) => [
      {
        name: 'scoringFormId',
        header: () => 'Scoring Form',
        getValue: (row: ClinicalTrialInventoryMeasurementType) => {
          return getScoringFormById(row, ctx.clinicalTrialInventoryState);
        },
        ...commonColumnProps,
      },
    ],
    instruments: (ctx: ClinicalInventoryColumnsContext) => [
      {
        name: 'scoringFormId',
        header: () => 'Scoring Form',
        getValue: (row: ClinicalTrialInventoryInstrumentType) => {
          return getScoringFormById(row, ctx.clinicalTrialInventoryState);
        },
        ...commonColumnProps,
      },
    ],
    reportTemplates: () => [],
    tags: () => [],
    scoringForms: () => [],
    functions: () => [],
    readers: (ctx: ClinicalInventoryColumnsContext) => [
      {
        name: 'dynamikaUserId',
        header: () => 'User',
        getValue: (row: ClinicalTrialInventoryReaderType) => {
          return getUserById(row, ctx.allTeamMembers);
        },
        ...commonColumnProps,
      },
    ],
    dictionaries: () => [],
  },
};
